import Vue from 'vue'
import VueRouter from 'vue-router'


import Home from '../views/Home.vue'

import Category from '../views/Category.vue'
import Post from '../views/Post.vue'
import VisitInfo from '../views/VisitInfo.vue'

import SiteMap from '../views/SiteMap.vue'

import LessonPlansLogin from '../views/LessonPlansLogin.vue'
import LessonPlans from '../views/LessonPlans.vue'

import Reservation from '../views/Reservation.vue'
import ReservationForm from '../views/ReservationForm.vue'
import ReservationSearch from '../views/ReservationSearch.vue'

import ShiftSchedule from '../views/ShiftSchedule.vue'
import VolunteerSchedule from '../views/VolunteerSchedule.vue'

import ShiftScheduleManager from '../views/ShiftScheduleManager.vue'
import VolunteerScheduleManager from '../views/VolunteerScheduleManager.vue'

import ScheduleLogin from '../views/ScheduleLogin.vue'
import ScheduleList from '../views/ScheduleList.vue'

import VolunteerApplicationForm from '../views/VolunteerApplicationForm.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/Category/:CId',
    name: 'Category',
    component: Category
  },
  {
    path: '/Post/:PId',
    name: 'Post',
    component: Post
  },
  {
    path: '/VisitInfo',
    name: 'VisitInfo',
    component: VisitInfo
  },
  {
    path: '/SiteMap',
    name: 'SiteMap',
    component: SiteMap
  },
  {
    path: '/LessonPlansLogin',
    name: 'LessonPlansLogin',
    component: LessonPlansLogin
  },
  {
    path: '/LessonPlans',
    name: 'LessonPlans',
    component: LessonPlans
  },
  {
    path: '/Reservation',
    name: 'Reservation',
    component: Reservation
  },
  {
    path: '/ReservationForm',
    name: 'ReservationForm',
    component: ReservationForm
  },
  {
    path: '/ReservationSearch',
    name: 'ReservationSearch',
    component: ReservationSearch
  },
  {
    path: '/ShiftSchedule/:csId',
    name: 'ShiftSchedule',
    component: ShiftSchedule
  },
  {
    path: '/VolunteerSchedule/:csId',
    name: 'VolunteerSchedule',
    component: VolunteerSchedule
  },
  {
    path: '/ShiftScheduleManager/:csId',
    name: 'ShiftScheduleManager',
    component: ShiftScheduleManager
  },
  {
    path: '/VolunteerScheduleManager/:csId',
    name: 'VolunteerScheduleManager',
    component: VolunteerScheduleManager
  },
  {
    path: '/ScheduleLogin',
    name: 'ScheduleLogin',
    component: ScheduleLogin
  },
  {
    path: '/ScheduleList',
    name: 'ScheduleList',
    component: ScheduleList
  },
  {
    path: '/VolunteerApplicationForm',
    name: 'VolunteerApplicationForm',
    component: VolunteerApplicationForm
  },
]

const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 如果有保存的位置（例如使用瀏覽器的前進/後退按鈕），則返回該位置
    if (savedPosition) {
      return savedPosition
    } else {
      // 否則滾動到頁面頂部
      return { x: 0, y: 0 }
    }
  }
})

export default router
